import { injectable } from 'inversify';
import { titleCase } from 'title-case';
import { Component } from '../../../concepts/objects';
import { ParticipantManager } from '../../canvas/participants/ParticipantManager';
import { resolve } from '../../Container';
import { DefineDateColumn } from '../dataExport/addons/DateDimension';
import { DefineSimpleDimension } from '../dataExport/addons/SimpleDimension';
import { FromFirstMatchExportAdapter } from '../dataExport/ExportAdapter';
import { RoadmapCard } from './RoadmapCard';
import { RoadmapCardEndDate, RoadmapCardStartDate, RoadmapCardTargetDate } from './RoadmapCardAssocs';

@injectable()
export class RoadmapCardExports extends FromFirstMatchExportAdapter {

    @resolve(ParticipantManager) private participants!: ParticipantManager;

    protected selector = (c: Component) => c.is(RoadmapCard);

    public readonly id = 'RoadmapCardExports';
    public readonly label = 'Roadmap Cards';
    public readonly priority = 10;
    public readonly defaults = true;
    public readonly columns = [
        DefineSimpleDimension(
            RoadmapCard,
            'Text',
            'Adds a column that contains the text of each Roadmap Card.',
            x => x.label
        ),
        DefineSimpleDimension(
            RoadmapCard,
            'Punctuality',
            'Adds a column that contains the punctuality status of each Roadmap Card.',
            x => titleCase(x.punctuality)
        ),
        DefineDateColumn(
            RoadmapCard,
            'Start Date',
            'Adds a column that contains the start date of each Roadmap Card.  Several date formatting options are available.',
            'shortDate',
            x => RoadmapCardStartDate.get(x)
        ),
        DefineDateColumn(
            RoadmapCard,
            'End Date',
            'Adds a column that contains the end date of each Roadmap Card.  Several date formatting options are available.',
            'shortDate',
            x => RoadmapCardEndDate.get(x)
        ),
        DefineDateColumn(
            RoadmapCard,
            'Original Date',
            'Adds a column that contains the original date of each Roadmap Card (if the card is early or late).  Several date formatting options are available.',
            'shortDate',
            x => RoadmapCardTargetDate.get(x)
        ),
    ];
}
